var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-camera-default"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camera-default",
    clipPath: "url(#clip-camera-default)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_icon-camera_211634",
    transform: "translate(0.989 4.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31653",
    "data-name": "Path 31653",
    d: "M73.759,99.435H69.212L66.49,96.687s-.013-.013-.02-.013l-.013-.013h0A2.2,2.2,0,0,0,64.887,96H59.229a2.228,2.228,0,0,0-1.657.734v.007l-2.661,2.694H50.263A2.237,2.237,0,0,0,48,101.672v13.613a2.265,2.265,0,0,0,2.263,2.27h23.5a2.27,2.27,0,0,0,2.263-2.27V101.672A2.241,2.241,0,0,0,73.759,99.435ZM62.011,114.154a6.238,6.238,0,1,1,6.224-6.238A6.243,6.243,0,0,1,62.011,114.154Zm11.323-11.114a.95.95,0,1,1,.943-.95A.947.947,0,0,1,73.334,103.039Z",
    transform: "translate(-48 -96)",
    fill: "#c2cce1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31654",
    "data-name": "Path 31654",
    d: "M190.9,202.9a4.715,4.715,0,1,0,4.7,4.715A4.7,4.7,0,0,0,190.9,202.9Z",
    transform: "translate(-176.891 -195.699)",
    fill: "#c2cce1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.51c9d6d920e6de8f9cdc9094c67ae2bb.svg";
export { ForwardRef as ReactComponent };